import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonClassDiscriminatorClass;
function JsonClassDiscriminator() {
  if (JsonClassDiscriminatorClass === VOID) {
    class $ {}
    initMetadataForClass($, 'JsonClassDiscriminator');
    JsonClassDiscriminatorClass = $;
  }
  return JsonClassDiscriminatorClass;
}
var JsonIgnoreUnknownKeysClass;
function JsonIgnoreUnknownKeys() {
  if (JsonIgnoreUnknownKeysClass === VOID) {
    class $ {}
    initMetadataForClass($, 'JsonIgnoreUnknownKeys');
    JsonIgnoreUnknownKeysClass = $;
  }
  return JsonIgnoreUnknownKeysClass;
}
var JsonNamesClass;
function JsonNames() {
  if (JsonNamesClass === VOID) {
    class $ {}
    initMetadataForClass($, 'JsonNames');
    JsonNamesClass = $;
  }
  return JsonNamesClass;
}
//region block: exports
export {
  JsonClassDiscriminator as JsonClassDiscriminator3irfencugy52m,
  JsonIgnoreUnknownKeys as JsonIgnoreUnknownKeys124eml6s7t6h6,
  JsonNames as JsonNames3i9ju5gyx18ko,
};
//endregion

//# sourceMappingURL=JsonAnnotations.mjs.map
